import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './rootReducer';

type CurrentSelectedEntityDetails = {
  customerName?: string;
  entityId?: string;
  name?: string;
  uri?: string;
};

type FarmDetailsStateType = {
  currentSelectedEntityDetails: CurrentSelectedEntityDetails | null;
};

export const farmDetailsInitialState: FarmDetailsStateType = {
  currentSelectedEntityDetails: null,
};

export const farmDetails = createSlice({
  name: 'farmDetails',
  initialState: farmDetailsInitialState,
  reducers: {
    setCurrentSelectedEntity: (
      state,
      action: PayloadAction<CurrentSelectedEntityDetails>,
    ) => {
      state.currentSelectedEntityDetails = action.payload;
    },
    resetCurrentSelectedEntity: (state) => {
      state.currentSelectedEntityDetails = null;
    },
  },
});

export const { setCurrentSelectedEntity, resetCurrentSelectedEntity } =
  farmDetails.actions;

export const farmsDetailsSelectors = {
  selectCurrentSelectedEntity: (state: RootState) =>
    state.farmDetails.currentSelectedEntityDetails,
};

export default farmDetails.reducer;
